/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const MaterialFunctionId = zod.uuid().describe("Material Function identity.");

export type MaterialFunctionId = zod.input<typeof MaterialFunctionId>;
export type MaterialFunctionIdOutput = zod.output<typeof MaterialFunctionId>;
